
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Artboard","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Directions","transform":"translate(-1.05 -.1)"}},[_c('g',{attrs:{"id":"Vertical","transform":"translate(1 .1)"}},[_c('g',{attrs:{"id":"Justification","transform":"translate(0 .4)"}},[_c('g',{attrs:{"id":"Space-around","transform":"rotate(-90 7.1 7.05)"}},[_c('path',{attrs:{"id":"Line-Copy-2","stroke-opacity":".605","stroke":"#CCCEDC","stroke-linecap":"square","d":"M13.05 0v16"}}),_c('path',{attrs:{"id":"Rectangle-Copy","fill":"#CCCEDC","transform":"rotate(90 3.95 8)","d":"M-.05 6.25h8v3.5h-8z"}}),_c('path',{attrs:{"id":"Rectangle","fill":"#CCCEDC","transform":"rotate(90 9.15 8)","d":"M5.15 6.25h8v3.5h-8z"}}),_c('path',{attrs:{"id":"Line","stroke-opacity":".605","stroke":"#CCCEDC","stroke-linecap":"square","d":"M.05 0v16"}})])])])])])])
          )
        }
      }
    